import React from "react";

// import useAPI from "../hooks/useAPI";

import { makeStyles } from "@mui/styles";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import { Form } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: 1,
    width: "100%",
  },
  actions: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: 40,
    padding: "10px 0",
  },
  checkboxes: {
    display: "block",
  },
}));

const AdminPickAndSelectSite = (props) => {
  const {
    platforms,
    platform,
    onToggle,
    disabledButton,
    onCancelAction,
    onSubmit,
    submitting,
    duplicateArticles,
    onToggleDuplicateArticles,
  } = props;
  console.log("AdminPickAndSelectSite", AdminPickAndSelectSite);
  const classes = useStyles();

  const stripHttp = (platform) => {
    return platform.replace("https://", "");
  };

  const isSelected = (p) => {
    return !!platform.find((p2) => parseInt(p2.id, 10) === parseInt(p, 10));
  };

  return (
    <div>
      <FormGroup className={classes.checkboxes}>
        <InputLabel shrink htmlFor="select-multiple-native">
          Sélectionnez les sites sur lequels vous souhaitez afficher vos
          articles à vendre.
        </InputLabel>

        {platforms.map((platform) => (
          <FormControlLabel
            key={platform.id}
            control={
              <Checkbox
                checked={isSelected(platform.id)}
                onChange={onToggle}
                name={stripHttp(platform.id)}
              />
            }
            label={stripHttp(platform.name)}
          />
        ))}
      </FormGroup>

      <hr />

      <FormControl className={classes.formControl}>
        {/* add a checkbox to specify if articles must be duplicated */}
        <FormControlLabel
          control={
            <Checkbox
              checked={duplicateArticles}
              onChange={onToggleDuplicateArticles}
              name="duplicate-articles"
            />
          }
          label="Dupliquer les articles existants sur les nouveaux sites sélectionnés"
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <div className={classes.actions}>
          <Button variant="contained" onClick={onCancelAction}>
            Annuler
          </Button>
          <Button
            variant="contained"
            disabled={disabledButton || submitting}
            onClick={onSubmit}
          >
            {submitting ? "processing ..." : "Sauver"}
          </Button>
        </div>
      </FormControl>
    </div>
  );
};

export default AdminPickAndSelectSite;
